import React, { useState } from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import { BrowserRouter as Router, Route, Switch, Link, useNavigate } from 'react-router-dom';
import logo from '../../img/logo.png';
import './Navbar.css';

const Navbar1 = ({ language, setLanguage }) => {
  const navigate = useNavigate();
  const handleLanguageChange = (lang) => {
    setLanguage(lang);  // Altera o idioma
    navigate(lang === 'en' ? '/ingles' : '/');
  };

  return (
    <Navbar fixed="top" expand="lg" className="navbar-custom">
      <div className="container-fluid" style={{ padding: '0px', overflowX: 'hidden' }}>
        {/* Logo */}
        <Navbar.Brand href="/" className="d-flex align-items-center" style={{ backgroundColor: '#fff', width: '20%', height: '6.25rem', display: 'flex', margin: '0px', justifyContent: 'center', overflow: 'hidden' }}>
          <img src={logo} alt="Logo" style={{ height: '100%', width: 'auto' }} />
        </Navbar.Brand>

        {/* Botão de alternância para dispositivos móveis */}
        <Navbar.Toggle aria-controls="navbarNav" style={{ color: '#fff' }} />

        {/* Itens da Navbar */}
        <Navbar.Collapse id="navbarNav">
          <Nav variant="underline" className="ms-auto" style={{ marginRight: '0px' }}>
            {/* Links da navbar baseados no idioma */}
            <Nav.Link as={Link} to={language === 'en' ? "/ingles" : "/"} className="nav-link-custom">{language === 'en' ? 'Home' : 'inicio'}</Nav.Link>
            <Nav.Link as={Link} to={language === 'en' ? "/OurTeam" : "/NossoTeam"} className="nav-link-custom">{language === 'en' ? 'Who we are' : 'Quem somos'}</Nav.Link>
            <Nav.Link as={Link} to={language === 'en' ? "/OurServices" : "/NossosServicos"} className="nav-link-custom">{language === 'en' ? 'Services' : 'Serviços'}</Nav.Link>
            <Nav.Link as={Link} to={language === 'en' ? "/Projects" : "/Projetos"} className="nav-link-custom">{language === 'en' ? 'Projects' : 'Projectos'}</Nav.Link>
            <Nav.Link as={Link} to={language === 'en' ? "/Contact" : "/contacto"} className="nav-link-custom">{language === 'en' ? 'Contact' : 'Contactos'}</Nav.Link>

            {/* Links para trocar o idioma */}
            <Nav.Link onClick={() => handleLanguageChange('pt')} className="nav-link-custom">PT</Nav.Link>
            <Nav.Link onClick={() => handleLanguageChange('en')} className="nav-link-custom">EN</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </div>
    </Navbar>
  );
};
export default Navbar1